import { render, staticRenderFns } from "./ProviderSchedule.vue?vue&type=template&id=2444f12c&scoped=true&"
import script from "./ProviderSchedule.vue?vue&type=script&lang=js&"
export * from "./ProviderSchedule.vue?vue&type=script&lang=js&"
import style0 from "./ProviderSchedule.vue?vue&type=style&index=0&id=2444f12c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2444f12c",
  null
  
)

export default component.exports